import { createApp } from 'vue'
import roteador from './roteador'
import App from './App.vue'


createApp(App).use(roteador).mount('#app')
